import React from 'react';

function ScrollText(props) {
	return (
		<svg height="30" width="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M10.37 27.55c-0.22 0-0.44-0.02-0.65-0.05a2.5 2.5 0 0 1-3.04-2.45v-20.04l0-0.02a2.5 2.5 0 0 0-2.51-2.49h17.12a3.76 3.76 0 0 1 3.76 3.76v20.04a1.25 1.25 0 0 1-1.25 1.25h-13.43z" fill="#000" fillOpacity="0.4"/>
		<path d="M1.67 5.01a2.5 2.5 0 1 1 5.01 0v7.51h-2.09a2.92 2.92 0 0 1-2.92-2.92v-4.59z" fill="#000"/>
		<path d="M24.63 27.55h-15.44a2.5 2.5 0 0 0 2.5-2.5v-2.92c0-1.15 0.94-2.09 2.09-2.09h12.52c1.15 0 2.09 0.94 2.09 2.09v1.67a3.76 3.76 0 0 1-3.76 3.75z" fill="#000"/>
		<path d="M11.27 9.6a1.25 1.25 0 0 1 1.25-1.25h6.68a1.25 1.25 0 0 1 0 2.5h-6.68a1.25 1.25 0 0 1-1.25-1.25z" fill="#000" fillRule="evenodd"/>
		<path d="M11.27 14.61a1.25 1.25 0 0 1 1.25-1.25h6.68a1.25 1.25 0 0 1 0 2.5h-6.68a1.25 1.25 0 0 1-1.25-1.25z" fill="#000" fillRule="evenodd"/>
	</g>
</svg>
	);
};

export default ScrollText;